export enum PurchaseRequisitionStatus {
  Draft = 0,
  Submitted = 1,
  Discard = 2,
  Posted = 3,
}

export interface IPurchaseRequisitionListParams {
  page: number;
  record: number;
  isSaveAsDraft?: boolean;
  documentNumber?: string;
  requesterName?: string;
  vendorId?: string;
  dueDeliveryDate?: string | null | Date;
  sortFieldName?: string;
  sortType?: number;
  status?: PurchaseRequisitionStatus;
}

export interface IPurchaseRequisition {
  id: string;
  documentId: string;
  documentNumber: string;
  documentStatus: number;
  documentClass: number;
  organizationId: string;
  userId: string;
  createdDate: string;
  updatedDate: string;
  requesterName: string;
  vendorName: string;
  departmentDimension: string;
  manualDocumentJson: string;
  isDeleted: boolean;
  dueDeliveryDate: null | string;
  status: 0 | 1 | 2 | 3;
}

export interface PurchaseRequisitionResponse {
  purchaseRequisitions: IPurchaseRequisition[];
  hasNextPage: boolean;
}
export interface IPurchaserRequisitionItem {
  referenceCode: string;
  description: string;
  unitPrice: number;
  quantity: number;
}

export interface IPurchaserRequisitionById {
  documentId: string;
  purchaseRequisitionId: string;
  documentNumber: string;
  requesterName: string;
  departmentDimensionId: string;
  costCenterDimensionId: string;
  vendorId: string;
  dueDeliveryDate: string;
  isPosted: boolean;
  isSaveAsDraft: boolean;
  isRejected: boolean;
  rejectionReason: string | null;
  organizationId: string;
  userId: string;
  createdDate: string;
  updatedByUserId: string;
  updatedDate: string;
  deletedByUserId: string | null;
  deletedDate: string | null;
  isDeleted: boolean;
  companyID: string;
  priority: string;
  requirementJustification: string;
  shipToAddress: string;
  documentClass: string;
  accountClass: string;
  comments: string | null;
  documentDate: string;
  referenceDocumentURL: string;
  currency: string;
  items: IPurchaserRequisitionItem[];
}
